import React from "react";
import Header from "./../Common/Header";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import About4 from "./../Elements/About4";
import Specialization4 from "./../Elements/Specialization4";
import OurValue2 from "./../Elements/OurValue2";

import OurMission3 from "../Elements/OurMission3";
import { Helmet } from "react-helmet";

var bnrimg = require("./../../images/banner/Frame1.png");

class About extends React.Component {
  render() {
    const mobileView = window.innerWidth <= 768;
    const bannerStyle = {
      backgroundImage: `url(${bnrimg})`,
      backgroundSize: "cover",
      backgroundPosition: mobileView
        ? "35%  0px !important"
        : "center center !important",
    };
    return (
      <>
<Helmet>
  <title>About Cheran Machines India | Textile Machinery Manufacturer</title>

  <meta
    name="description"
    content="Cheran Machines India is a leading textile machinery manufacturer in India, delivering innovative solutions for garment and textile printing."
  />

  <meta
    name="keywords"
    content="Cheran Machines India, Cheran Machines , textile machinery manufacturer India"
  />
  <link rel="canonical" href="https://www.cheranmachines.com/about" />
</Helmet>

        <Header />
        <div className="page-content">
          <Banner
            title="Innovative Textile and Garment Printing Solutions for Your Business"
            pagename="About Us"
            bgimage={bnrimg}
            bannerstyle={bannerStyle}
          />
          <About4 />
          <Specialization4 />
          <OurMission3 />
        </div>

        <Footer />
      </>
    );
  }
}

export default About;
